import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from "rxjs";

interface TranscriptLine {
    speaker: string;
    text: string;
}

@Component({
    selector: 'app-call-transcript',
    templateUrl: './call-transcript.component.html',
    styleUrls: ['./call-transcript.component.scss'],
})
export class CallTranscriptComponent implements OnInit {

    public onClose: Subject<any>;
    transcriptLines: TranscriptLine[] = [];
    data: any;
    isDialpad = false;

    constructor(public bsModalRef: BsModalRef) { }

    ngOnInit() {
        if (this.isDialpad) {
            this.transcriptLines = this.parseDialpadSegments(this.data);
            return;
        }

        if (!this.data) return;

        const rawLines = this.data.split('\n');

        for (let line of rawLines) {
            line = line.trim();

            if (!line) {
                continue;
            }

            if (line.startsWith('User:')) {
                this.transcriptLines.push({
                    speaker: 'User',
                    text: line.substring(5).trim()
                });
            } else if (line.startsWith('Agent:')) {
                this.transcriptLines.push({
                    speaker: 'Agent',
                    text: line.substring(6).trim()
                });
            } else {
                this.transcriptLines.push({
                    speaker: '',
                    text: line
                });
            }
        }
    }

    // Dialpad transcript is a JSON string: [{speaker, text}, ...] (or legacy { "Speaker": "text" })
    private parseDialpadSegments(raw: any): TranscriptLine[] {
        const lines: TranscriptLine[] = [];
        if (!raw) {
            return lines;
        }

        let parsed: any;
        try {
            parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        } catch (e) {
            // plain text shape: "Speaker : text" per line
            return this.parsePlainTranscript(String(raw));
        }

        if (Array.isArray(parsed)) {
            for (const item of parsed) {
                if (item && item.speaker !== undefined && item.text !== undefined && item.text !== null) {
                    lines.push({ speaker: String(item.speaker), text: String(item.text) });
                }
            }
        } else if (parsed && typeof parsed === 'object') {
            // legacy shape: { "Speaker": "text" }
            Object.keys(parsed).forEach(speaker => {
                const text = parsed[speaker];
                if (text !== null && text !== undefined && typeof text !== 'object') {
                    lines.push({ speaker: speaker, text: String(text) });
                }
            });
        }
        return lines;
    }

    private parsePlainTranscript(raw: string): TranscriptLine[] {
        const lines: TranscriptLine[] = [];
        raw.split('\n').forEach(line => {
            line = line.trim();
            if (!line) {
                return;
            }
            const idx = line.indexOf(' : ');
            if (idx > -1 && !line.startsWith('=')) {
                lines.push({ speaker: line.substring(0, idx).trim(), text: line.substring(idx + 3).trim() });
            } else {
                lines.push({ speaker: '', text: line });
            }
        });
        return lines;
    }

    closePanel() {
        this.bsModalRef.hide();
        if (this.onClose) {
            this.onClose.next('close');
            this.onClose.complete();
        }
    }
}